/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `v2_connection_node` - v2_connection_node
 * * `v2_pipe` - v2_pipe
 * * `v2_orifice` - v2_orifice
 * * `v2_culvert` - v2_culvert
 * * `v2_channel` - v2_channel
 * * `v2_weir` - v2_weir
 * @export
 */
export const ContentTypeEnum = {
  V2_CONNECTION_NODE: "v2_connection_node",
  V2_PIPE: "v2_pipe",
  V2_ORIFICE: "v2_orifice",
  V2_CULVERT: "v2_culvert",
  V2_CHANNEL: "v2_channel",
  V2_WEIR: "v2_weir",
} as const;
export type ContentTypeEnum = (typeof ContentTypeEnum)[keyof typeof ContentTypeEnum];

export function instanceOfContentTypeEnum(value: any): boolean {
  for (const key in ContentTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(ContentTypeEnum, key)) {
      if (ContentTypeEnum[key as keyof typeof ContentTypeEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ContentTypeEnumFromJSON(json: any): ContentTypeEnum {
  return ContentTypeEnumFromJSONTyped(json, false);
}

export function ContentTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ContentTypeEnum {
  return json as ContentTypeEnum;
}

export function ContentTypeEnumToJSON(value?: ContentTypeEnum | null): any {
  return value as any;
}

export function ContentTypeEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): ContentTypeEnum {
  return value as ContentTypeEnum;
}
